<template>
  <div>
    <ul class="heading-ul mb-5">
      <li>
        <router-link :to="{ path: '/setup/discount-promotion' }" class="vx-row">
          <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
          <h4>{{ $t("setup.label.CreatePromotion") }}</h4>
        </router-link>
      </li>
    </ul>
    <ValidationObserver ref="observer">
      <vx-card>
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.PromotionCode')"
            >
              <vs-input
                :label="$t('setup.label.PromotionCode')"
                v-model="discountCode"
                class="w-full mb-2 font-semibold starlabel text-uppercase"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.PromotionName')"
            >
              <vs-input
                :label="$t('setup.label.PromotionName')"
                class="w-full mb-2 font-semibold starlabel text-uppercase"
                v-model="discountName"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mt-4">
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.StartDate")
                }}<span class="required">*</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.StartDate')"
              >
                <datepicker
                  :placeholder="$t('setup.label.select_date')"
                  v-model="startDate"
                  class="mb-2 font-semibold"
                  :disabled-dates="{ from: new Date() }"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.EndDate")
                }}<span class="required">*</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.EndDate')"
              >
                <datepicker
                  :placeholder="$t('setup.label.select_date')"
                  v-model="endDate"
                  class="mb-2 font-semibold"
                  :disabled-dates="{ to: new Date(new Date().toDateString()) }"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.Status") }}
                <span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Status')"
              >
                <v-select
                  label="label"
                  :options="statusOption"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                  v-model="status"
                >
                  <template v-slot:option="option">{{ option.label }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.Type") }}
                <span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Type')"
              >
                <v-select
                  label="label"
                  :options="typeOption"
                  v-model="type"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">{{ option.label }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required|numeric"
              v-slot="{ errors }"
              :name="$t('setup.label.Priority')"
            >
              <vs-input
                :label="$t('setup.label.Priority')"
                v-model="priority"
                class="w-full mb-2 font-semibold starlabel"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
        </div>
      </vx-card>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("setup.label.Reset") }}</vs-button
          >
          <vs-button class="mr-3 mb-2 footerButton-next" @click="addTrigger">{{
            $t("setup.label.Submit")
          }}</vs-button>
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import moment from "moment";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  components: {
    "v-select": vSelect,
    Datepicker,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      startDate: moment().format("DD MMMM YYYY"),
      endDate: null,
      discountCode: "",
      discountName: "",
      status: "ACTIVE",
      type: null,
      priority: "",
      statusOption: ["ACTIVE", "INACTIVE"],
      typeOption: ["Parallel", "Sequential"],
      warningPopup: false,
      warningText: "",
      errorMessage: "",
    };
  },
  methods: {
    async addTrigger() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        const payload = {
          code: this.discountCode,
          name: this.discountName,
          startDate: moment(this.startDate).format("DD MMMM yyyy"),
          endDate: moment(this.endDate).format("DD MMMM yyyy"),
          status: this.status,
          type: this.type,
          priority: this.priority,
          dateFormat: "dd MMMM yyyy",
          locale: "en",
          offerType: "Promotion",
        };
        const data = await this.$store.dispatch(
          "discount/createDiscount",
          payload
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Promotion Created Successfully!",
          type: "success",
        });
        this.$router.push(
          `/setup/discount-promotion`
        );
        this.resetForm();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    cancel() {
      this.$router.push({ path: "/setup/discount" });
    },
    resetForm() {
      this.discountCode = "";
      this.discountName = "";
      this.startDate = "";
      this.endDate = "";
      this.status = "";
      this.type = "";
      this.priority = "";
      if (this.$refs.observer) {
        this.$refs.observer.reset();
      }
    },
  },
};
</script>
<style>
.text-uppercase .vs-con-input .vs-inputx {
  text-transform: uppercase !important;
}
.trigger-btn {
  height: 39px;
  width: 30% !important;
}
</style>
